import React from 'react';
import { Link } from 'react-router-dom';
import './Cards.css';
import dressesImg from './Assets/dresses.jpg';
import suits from './Assets/suits.jpg';
import pants from './Assets/pants.jpg';

export default function Cards() {
  const services = [
    {
      image: dressesImg,
      title: 'Dress Alterations',
      description: 'Wedding gowns, bridesmaid dresses, prom dresses, and everyday wear tailored to perfection.',
      link: '/services/wedding-dresses',
    },
    {
      image: suits,
      title: 'Suit Tailoring',
      description: 'Expert alterations for jackets, blazers, and complete suits for the perfect professional look.',
      link: '/services/suits',
    },
    {
      image: pants,
      title: 'Pants & Jeans',
      description: 'Hemming, tapering, and waist adjustments for all types of pants and denim.',
      link: '/services/pants',
    },
  ];

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        <div className="section-header">
          <h2>Popular Services</h2>
          <p>Expert alterations for all your clothing needs</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Link to={service.link} className="service-card" key={index}>
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <span>Learn More</span>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </Link>
          ))}
        </div>
        <div className="services-cta">
          <p>Need something specific? We handle all types of alterations.</p>
          <Link to="/services" className="btn-primary">
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
}
